import { styled } from 'linaria/react';

export const Container = styled.div<{ noXPadding: boolean }>`
  width: 100%;
  height: 100%;
  padding: ${props => (props.noXPadding ? '0' : '0 var(--space-400) var(--space-200) var(--space-400)')};

  @media (--only-mobile) {
    padding: 0;
  }
`;
